module.exports = __webpack_public_path__ + "static/media/daily-question-wrong.3df559a0.png";